//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import CharacterCount from '@tiptap/extension-character-count';

export default {
  components: { EditorContent },
  props: {
    size: {
      type: String,
      default() {
        return '500';
      },
    },
  },
  data() {
    return {
      editor: null,
      focused: false,
      value: '',
      tippy: null,
      linkText: '',
      inputMark: false,
    };
  },
  computed: {
    charCount() {
      return this.editor?.storage?.characterCount?.characters() ?? 0;
    },
  },
  mounted() {
    window.tipThis = this;
    this.editor = new Editor({
      content: this.value,
      extensions: [
        StarterKit,
        Link.configure({
          openOnClick: false,
        }),
        CharacterCount.configure({
          limit: this.size,
        }),
      ],
      editorProps: {
        attributes: {
          class: 'mastergo-richtext-editor',
        },
      },
      onFocus: () => {
        this.focused = true;
      },
      onBlur: () => {
        this.focused = true;
      },
      onUpdate: () => {
        this.$emit('input', this.editor.getHTML());
      },
    });
  },

  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    displayLinkInput(show) {
      this.inputMark = show;
      if (show) {
        this.$nextTick(() => {
          this.$refs.linkInput.focus();
        });
      }
    },

    handleLinkInputBlur() {
      this.displayLinkInput(false);
    },

    getText() {
      if (!this.editor) return '';
      return this.editor.getText();
    },
    getHtml() {
      if (!this.editor) return '';
      return this.editor.getHTML();
    },
    setText(value) {
      this.editor.commands.setContent(value, false);
    },
    setHtml(value) {
      this.editor.commands.setContent(value, true);
    },
    alertLinkInput() {
      if (!this.editor) return;
      if (this.editor.isActive('link')) {
        // unset link
        this.editor.chain().focus().unsetLink().run();
        return;
      }

      // 检查是否选中了文本
      const selection = this.editor.state.selection;
      if (selection.$anchor.pos === selection.$head.pos) return;

      const previousUrl = this.editor.getAttributes('link').href;
      this.linkText = previousUrl;

      if (!this.editor) return;

      this.displayLinkInput(true);
    },

    setLink() {
      if (!this.editor) return;
      // empty
      if (!this.linkText) {
        this.editor.chain().focus().extendMarkRange('link').unsetLink().run();

        return;
      }

      // 如果用户输入的 URL 没有 http(s) 前缀，则自动添加 http 前缀
      const linkText = this.linkText.startsWith('http') ? this.linkText : `http://${this.linkText}`;

      // update link
      this.editor.chain().focus().extendMarkRange('link').setLink({ href: linkText }).run();

      // reset
      this.linkText = '';
    },
  },
};
